import { fetchUtils } from '../utils/fetchUtils'

export function termsCheckboxChanged(lotPublicId: string, checked: boolean, msg: string) {
	const request = {
		lotPublicId,
		checkboxState: checked,
		message: msg
		// TODO csrfToken: CSRF_TOKEN
	}
	// `false`: a public pub page, where the default would send the customer to /login on a 401
	fetchUtils.post('/api/checkbox', request, false).catch(fetchUtils.catchErrorAndShowNotification())
}
